import { Pipe, PipeTransform } from '@angular/core';
import {
  ExpertWorkspaceRecord,
  SummarizedExpertWorkspaceRecord,
} from '@libs/shared/api';

@Pipe({
  name: 'expertWorkspaceImageFileKey',
  standalone: true,
})
export class ExpertWorkspaceImageFileKeyPipe implements PipeTransform {
  transform(
    workspace: SummarizedExpertWorkspaceRecord | ExpertWorkspaceRecord
  ): string {
    return workspace?.imageFileKey ?? `media/images/${workspace.id}`;
  }
}
